<template>
  <div class="recharge">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="充值">
          <div class="content noSelect">
            <div class="recharge-title">充值金额(元)</div>
            <div class="recharge-list">
              <div class="recharge-item" v-for="(item, index) in rechargeList" :key="index" :class="{ active: item === money }" @click="onSelectRecharge(item)">￥{{ item }}</div>
            </div>

            <div class="recharge-form">
              <span class="recharge-form-key">充值金额：</span>
              <el-input style="width: 300px" clearable v-model="money" placeholder="请输入充值金额"></el-input>
            </div>

            <div class="recharge-btn" @click="onRecharge">确认充值</div>

            <div class="advert-box" v-if="advert.bottom && advert.bottom.images" :style="`background-image: url('${API_URL + advert.bottom.images}')`" @click="onJumpPages(advert.bottom.link)"></div>

            <!-- 新支付对接 -->
            <iframe
              ref="iframe"
              id="iframe"
              frameborder="0"
              :src="paySrc"
              v-show="paySrc.indexOf('127.0.0.1') == -1 && paySrc.length > 5"
              style="height: 900px;width: 100%; overflow-y:hidden;margin-top:20px;"
            >
            </iframe>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>

    <div class="pay-meng-main" v-if="dialogVisible">
      <div class="pay-main">
        <i class="close-icon el-icon-error" @click="onClosePay"></i>
        <div v-if="!is_pay_success" class="pay-content">
          <p class="pay-title">请用<span class="zhifubao">支付宝</span>扫描下方二维码充值</p>
          <img class="zfb-code" :src="payCode" alt="" />
          <p class="pay-money">扫码充值：{{ payMoney }}元</p>
        </div>
        <div v-if="!is_pay_success" class="pay-footer">
          <p class="pay-tips1">无需备注，自动转账</p>
          <p class="pay-tips2">充值成功到账后本页面将出现充值成功提示！</p>
        </div>
        <div class="paySuccess" v-if="is_pay_success">
          <div class="pay-success-top">
            <i class="el-icon-success"></i>
            <div class="pay-success-title">充值成功</div>
            <p class="pay-tips">充值记录可以在充值记录查看</p>
            <p class="pay-tips">土豪，可以去下单啦！</p>
          </div>

          <div class="button-box">
            <a href="javascript:void(0)" class="btn btn2" @click="onPayOk(0)">关 闭</a>
            <a href="javascript:void(0)" class="btn btn1" @click="onPayOk(1)">去下单</a>
          </div>
        </div>
      </div>
    </div>

    <loading ref="loading"></loading>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";
import { apiWalletCheckPay, apiWalletOnLinePut } from "@/api/api";

export default {
  name: "recharge",
  components: { headerNav, userNav, footerBox },
  data() {
    return {
      dialogVisible: false,
      is_pay_success: false,
      loadingData: false,
      tableData: [],
      rechargeList: [10, 50, 100, 300, 500, 1000],
      money: 10,
      payCode: "",
      closeTime: "",
      payMoney: 0,
      paySrc: "",
    };
  },
  computed: {
    advert() {
      let info = null;
      let advert = {};
      if (this.$store.getters.advert) {
        info = this.$store.getters.advert;
      } else {
        info = localStorage.getItem("advertConfig");
        if (info) {
          info = JSON.parse(info);
        }
      }
      if (info) {
        for (let i = 0; i < info.recharge.length; i++) {
          advert[info.recharge[i].key] = info.recharge[i];
        }
      }
      return advert;
    },
  },
  watch: {
    paySrc(val, oldVal) {
      // console.log("paySrc = " + val + " , oldValue = " + oldVal)
      if (val.indexOf("127.0.0.1") > -1) {
        this.is_pay_success = true;
        this.$store.dispatch("GetUserInfo");
      }
    },

    dialogVisible(val, oldVal) {
      if (!val) {
        console.log("关闭了弹窗");
        clearInterval(this.closeTime);
      } else {
        console.log("打开了弹窗");
      }
    },
  },
  methods: {
    onJumpPages(url) {
      if (url) {
        this.$router.push(url);
      }
    },

    onPayOk(type) {
      if (type === 1) {
        this.$router.push("/order/add");
      } else {
        this.dialogVisible = false;
        this.is_pay_success = false;
      }
    },
    // 我已支付|稍后操作
    onClosePay() {
      this.dialogVisible = false;
    },
    onSelectRecharge(money) {
      this.money = money;
    },
    // 充值
    onRecharge() {
      if (!this.money || this.money <= 0) {
        this.$message.info("请输入充值金额");
        return false;
      }
      this.paySrc = "";
      this.dialogVisible = false;
      this.$refs.loading.open();
      apiWalletOnLinePut({
        money: this.money,
        type: "web",
      }).then(res => {
        if (res.code === 1) {
          if (res.data.type == "new") {
            this.$refs.loading.close();
            window.open(res.data.url);
            this.closeTime = setInterval(() => {
              apiWalletCheckPay({ orderid: res.data.orderid }).then(res => {
                if (res.code === 1) {
                  this.is_pay_success = true;
                  this.$store.dispatch("GetUserInfo");
                  clearInterval(this.closeTime);
                }
              });
            }, 2000);
            return;
          }
          if (typeof res.data.pid == "undefined") {
            this.$refs.loading.close();
            if (typeof res.data.paytotal != "undefined") {
              this.payMoney = res.data.paytotal;
            }

            // this.$alert('为避免延迟到账或不到账，请务必准确支付<strong>这是 <i>HTML</i> 片段</strong>', 'HTML 片段', {
            //   dangerouslyUseHTMLString: true
            // });
            // return;

            this.$confirm(
              '为避免延迟到账或不到账，请务必准确支付<strong class="payMoney">' +
                this.payMoney +
                "</strong>元,最终到账金额<strong class='payMoney'>" +
                this.payMoney +
                "</strong>元！<br><p class='payMoney'>注意:不按提示金额支付不到账！！！</p>",
              "重要提示",
              {
                confirmButtonText: "确定",
                type: "warning",
                dangerouslyUseHTMLString: true,
              }
            )
              .then(() => {
                if (typeof res.data.yzf == "undefined") {
                  this.payCode = this.API_URL + "api/wallet/getQrcode.html?text=" + res.data.url + "&orderid=" + res.data.orderid + "&paytotal=" + res.data.paytotal;
                  this.dialogVisible = true;
                } else {
                  window.open(res.data.url);
                }
                this.closeTime = setInterval(() => {
                  apiWalletCheckPay({ orderid: res.data.orderid }).then(res => {
                    if (res.code === 1) {
                      this.is_pay_success = true;
                      this.$store.dispatch("GetUserInfo");
                      clearInterval(this.closeTime);
                    }
                  });
                }, 2000);
              })
              .catch(() => {});
          } else {
            this.$refs.loading.close();
            this.paySrc = res.data.pay;
          }
        } else {
          this.$refs.loading.close();
          this.$message.info(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.payMoney {
  color: red;
  font-size: 20px;
}

.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 60px !important;
}

.el-tabs--border-card > .el-tabs__header {
  background-color: #e4e4e4;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  border: none;
}

.el-table td {
  color: #000000;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.recharge {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  // background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);

      .content {
        padding: 20px;
        min-height: calc(100vh - 300px);
        position: relative;

        .advert-box {
          cursor: pointer;
          width: 100%;
          height: 150px;
          background-repeat: no-repeat;
          background-size: 100% auto;
          background-position: center center;
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
        }

        .recharge-title {
          font-size: 16px;
          font-weight: bold;
          color: #0f375a;
          margin-bottom: 20px;
        }

        .recharge-list {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom: 20px;

          .recharge-item {
            width: 110px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: bold;
            border: 1px solid #0f375a;
            color: #0f375a;
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;

            &.active {
              background-color: #0f375a;
              color: #ffffff;
              border: 1px solid #0f375a;
            }

            &:hover {
              background-color: #0f375a;
              color: #ffffff;
              border: 1px solid #0f375a;
            }
          }
        }

        .recharge-form {
          display: flex;
          align-items: center;

          .recharge-form-key {
            font-weight: bold;
            font-size: 14px;
            color: #0f375a;
          }
        }

        .recharge-btn {
          width: 100px;
          height: 35px;
          background-color: #0f375a;
          color: #ffffff;
          text-align: center;
          line-height: 35px;
          cursor: pointer;
          margin-top: 20px;
        }

        .pages-box {
          margin-top: 20px;
        }
      }
    }
  }

  .pay-meng-main {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .pay-main {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      width: 320px;
      height: 370px;
      background-color: #0f375a;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 20px;

      .close-icon {
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        right: -10px;
        top: -10px;
        cursor: pointer;
      }

      .pay-content {
        width: 280px;
        height: 280px;
        background-color: #ffffff;
        border-radius: 10px 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        .zfb-code {
          width: 180px;
          height: 180px;
        }

        .pay-title {
          font-size: 14px;
          color: #000000;

          .zhifubao {
            color: #0f375a;
          }
        }

        .pay-money {
          font-size: 20px;
          font-weight: bold;
          color: #ff0000;
        }
      }

      .pay-footer {
        p {
          margin: 0;
          font-size: 12px;
          text-align: center;
          color: #ffffff;
          margin-top: 5px;
        }

        .pay-tips2 {
          font-weight: bolder;
        }
      }

      .paySuccess {
        background-color: #ffffff;
        width: 100%;
        height: 100%;
        border-radius: 10px 10px 0 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        padding: 30px 20px 20px;

        .pay-success-top {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          p {
            margin: 0;
            color: #000000;
          }

          .el-icon-success {
            font-size: 88px;
            color: #0f375a;
          }

          .pay-success-title {
            font-weight: bold;
            color: #000;
            font-size: 28px;
            margin: 15px 0;
          }
        }

        .button-box {
          display: flex;
          align-items: center;

          .btn {
            width: 100px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #979797;
            margin: 0 10px;
            color: #979797;
          }

          .btn1 {
            color: #0f375a;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recharge/index.vue